export default __webpack_public_path__ + "static/media/NotificationActivatedIcon.93caa5ba.svg";